export type Frame = { x: number; y: number; w: number; h: number; rotation: number };

/**
 * World placement of an object element: the element sits at the world origin with its size,
 * then `translate` + `rotate` around its centre (default transform-origin).
 */
export const frameTransform = (f: Frame): string => `translate(${f.x}px, ${f.y}px) rotate(${f.rotation}deg)`;

/** Hot-loop path: writes the same placement React would render, without a React render. */
export function writeFrame(el: HTMLElement, f: Frame): void {
  el.style.transform = frameTransform(f);
  el.style.width = `${f.w}px`;
  el.style.height = `${f.h}px`;
}
